<template>
  <div
    class="table">
    <div class="tr th">
      <span>Item</span>
      <span>Amount</span>
    </div>
    <div
      v-for="(inItem,index) in excessList"
      :key="index"
      class="tr">
      <span>{{ inItem.item }}</span>
      <span>{{ inItem.premium }}</span>
    </div>
    <!-- <template v-if="classId == 14">
      <div class="tr">
        <span>Third Party Property Damage Excess</span>
        <span>{{ formData.tppd_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>TPPD Young Driver Excess</span>
        <span>{{ formData.tppd_young_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>TPPD Inexperience Excess</span>
        <span>{{ formData.tppd_inexp_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>TPPD Unnamed Driver Excess</span>
        <span>{{ formData.tppd_unnamed_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Remark</span>
        <span>{{ formData.remark }}</span>
      </div>
    </template>
    <template v-else>
      <div class="tr">
        <span>Own Damage </span>
        <span>{{ getExText(formData.general_ex, formData.general_ex_posi, formData.general_ex_or_pol) }}</span>
      </div>
      <div class="tr">
        <span>Own Damage (China) </span>
        <span>{{ getExText(formData.china_general_ex, formData.china_general_ex_posi, formData.china_general_ex_or_pol) }}</span>
      </div>
      <div class="tr">
        <span>Own Damage (Guangdong)</span>
        <span>{{ getExText(formData.gd_general_ex, formData.gd_general_ex_posi, formData.gd_general_ex_or_pol) }}</span>
      </div>
      <div class="tr">
        <span>Theft</span>
        <span>{{ getExText(formData.theft_loss_ex, formData.theft_loss_ex_posi, formData.theft_loss_ex_or_pol) }}</span>
      </div>
      <div class="tr">
        <span>Theft (China) </span>
        <span>{{ getExText(formData.china_theft_loss_ex, formData.china_theft_loss_ex_posi, formData.china_theft_loss_ex_or_pol) }}</span>
      </div>
      <div class="tr">
        <span>Theft (Guangdong)</span>
        <span>{{ getExText(formData.gd_theft_loss_ex, formData.gd_theft_loss_ex_posi, formData.gd_theft_loss_ex_or_pol) }}</span>
      </div>
      <div class="tr">
        <span>Parking </span>
        <span>{{ formData.parking_damage_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Own Damage Young Driver</span>
        <span>{{ formData.young_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Own Damage Inexperienced Driver</span>
        <span>{{ formData.inexp_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Own Damage Unnamed Driver</span>
        <span>{{ formData.unnamed_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Third Party Property Damage </span>
        <span>{{ formData.tppd_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Third Party Property Damage Young Driver </span>
        <span>{{ formData.tppd_young_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Third Party Property Damage Inexperienced Driver </span>
        <span>{{ formData.tppd_inexp_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Third Party Property Damage Unnamed Driver </span>
        <span>{{ formData.tppd_unnamed_driver_ex | formatMoney(0) }}</span>
      </div>
      <div class="tr">
        <span>Remark</span>
        <span>{{ formData.remark }}</span>
      </div>
    </template> -->
  </div>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'ExcessInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    classId() {
      return this.formData.class_id
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    }
  },
  methods: {
    submitInfo() {
      const {
        tppd_ex,
        tppd_young_driver_ex,
        tppd_inexp_driver_ex,
        tppd_unnamed_driver_ex,
        remark,
        general_ex,
        general_ex_posi,
        general_ex_or_pol,
        china_general_ex,
        china_general_ex_posi,
        china_general_ex_or_pol,
        theft_loss_ex,
        theft_loss_ex_posi,
        theft_loss_ex_or_pol,
        china_theft_loss_ex,
        china_theft_loss_ex_posi,
        china_theft_loss_ex_or_pol,
        parking_damage_ex,
        young_driver_ex,
        inexp_driver_ex,
        unnamed_driver_ex,
        gd_general_ex,
        gd_general_ex_or_pol,
        gd_general_ex_posi,
        gd_theft_loss_ex,
        gd_theft_loss_ex_or_pol,
        gd_theft_loss_ex_posi
      } = this.formData
      return {
        tppd_ex,
        tppd_young_driver_ex,
        tppd_inexp_driver_ex,
        tppd_unnamed_driver_ex,
        remark,
        general_ex,
        general_ex_posi,
        general_ex_or_pol,
        china_general_ex,
        china_general_ex_posi,
        china_general_ex_or_pol,
        theft_loss_ex,
        theft_loss_ex_posi,
        theft_loss_ex_or_pol,
        china_theft_loss_ex,
        china_theft_loss_ex_posi,
        china_theft_loss_ex_or_pol,
        parking_damage_ex,
        young_driver_ex,
        inexp_driver_ex,
        unnamed_driver_ex,
        gd_general_ex,
        gd_general_ex_or_pol,
        gd_general_ex_posi,
        gd_theft_loss_ex,
        gd_theft_loss_ex_posi,
        gd_theft_loss_ex_or_pol
      }
    }
  }
}
</script>
